// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"db6fb40e","286":"f5a933cd","933":"389b95a9"}[chunkId] + ".chunk.css";
};